import { render, staticRenderFns } from "./Rivers.vue?vue&type=template&id=2463e52d&"
import script from "./Rivers.vue?vue&type=script&lang=js&"
export * from "./Rivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports